module.exports = __webpack_public_path__ + "static/img/far2_active.8266613f.png";